import React from 'react';
import '../App.scss';
import { formatDate } from '../utils';
import HTMLParserWrapperComponent from '../widgets/HTMLParserWrapperComponent';

function skillsLine(items) {
    return (items || []).map(i => i.value).join(', ');
}

function ATSResumeTemplate({ variant = 'classic', ...props }) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        educationData, jobData,
        linkedinURL, twitterURL, githubURL, websiteURL, showSocial,
    } = props;

    const contactParts = [email, phone, address].filter(Boolean);
    const socialParts = showSocial ? [linkedinURL, websiteURL, githubURL, twitterURL].filter(Boolean) : [];

    return (
        <div className={`ats-resume variant-${variant}`}>
            <div className="ats-header">
                <h1 className="ats-name">{name}</h1>
                {title ? <div className="ats-title">{title}</div> : null}
                {contactParts.length ? <div className="ats-contact">{contactParts.join(' | ')}</div> : null}
                {socialParts.length ? <div className="ats-contact">{socialParts.join(' | ')}</div> : null}
            </div>

            {about ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Summary</h2>
                    <div className="ats-body"><HTMLParserWrapperComponent content={about} /></div>
                </div>
            ) : null}

            {jobData?.length ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Experience</h2>
                    {jobData.map((job, idx) => (
                        <div className="ats-entry" key={idx}>
                            <div className="ats-entry-heading">
                                <span className="ats-entry-title">{job.jobTitle}</span>
                                {job.jobCompanyName ? <span> — {job.jobCompanyName}</span> : null}
                                {job.jobLocation ? <span>, {job.jobLocation}</span> : null}
                            </div>
                            <div className="ats-entry-dates">{formatDate(job.jobFromDate)} - {formatDate(job.jobToDate)}</div>
                            <div className="ats-body"><HTMLParserWrapperComponent content={job.jobSummary} /></div>
                        </div>
                    ))}
                </div>
            ) : null}

            {educationData?.length ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Education</h2>
                    {educationData.map((edu, idx) => (
                        <div className="ats-entry" key={idx}>
                            <div className="ats-entry-heading">
                                <span className="ats-entry-title">{edu.eduTitle}</span>
                                {edu.eduUniversity ? <span> — {edu.eduUniversity}</span> : null}
                                {edu.eduLocation ? <span>, {edu.eduLocation}</span> : null}
                            </div>
                            <div className="ats-entry-dates">{formatDate(edu.eduFromDate)} - {formatDate(edu.eduToDate)}</div>
                            {edu.eduSummary ? <div className="ats-body"><HTMLParserWrapperComponent content={edu.eduSummary} /></div> : null}
                        </div>
                    ))}
                </div>
            ) : null}

            {technicalSkills?.length ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Skills</h2>
                    <div className="ats-body">{skillsLine(technicalSkills)}</div>
                </div>
            ) : null}

            {softSkills?.length ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Additional Skills</h2>
                    <div className="ats-body">{skillsLine(softSkills)}</div>
                </div>
            ) : null}

            {languages?.length ? (
                <div className="ats-section">
                    <h2 className="ats-heading">Languages</h2>
                    <div className="ats-body">{skillsLine(languages)}</div>
                </div>
            ) : null}
        </div>
    );
}

export default ATSResumeTemplate;